import * as React from "react";
const SvgStar = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M10 2.5L11.6964 6.80127C11.853 7.19832 11.9313 7.39685 12.0512 7.56425C12.1574 7.71263 12.2874 7.84255 12.4358 7.94882C12.6032 8.06871 12.8017 8.14701 13.1987 8.3036L17.5 10L13.1987 11.6964C12.8017 11.853 12.6032 11.9313 12.4358 12.0512C12.2874 12.1574 12.1574 12.2874 12.0512 12.4358C11.9313 12.6032 11.853 12.8017 11.6964 13.1987L10 17.5L8.3036 13.1987C8.14701 12.8017 8.06871 12.6032 7.94882 12.4358C7.84255 12.2874 7.71263 12.1574 7.56425 12.0512C7.39685 11.9313 7.19832 11.853 6.80127 11.6964L2.5 10L6.80127 8.3036C7.19832 8.14701 7.39685 8.06871 7.56425 7.94882C7.71263 7.84255 7.84255 7.71263 7.94882 7.56425C8.06871 7.39685 8.14701 7.19832 8.3036 6.80127L10 2.5Z",
      stroke: "#121317",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgStar;
